import { render, staticRenderFns } from "./AlertaManutencaoForm.vue?vue&type=template&id=78010138&lang=html"
import script from "./AlertaManutencaoForm.vue?vue&type=script&lang=js"
export * from "./AlertaManutencaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports